import styled from 'styled-components';

import {breakpoint, colors} from 'theme';

export const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap-reverse;
    gap: 1.5rem;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const NavigationWrapper = styled.div<{needMargin?: boolean}>`
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 300px;
    flex: 0 1 auto;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: ${(p) => (p.needMargin ? '20px' : '0')};
    }
`;

export const ControlsWrapper = styled.div`
    display: flex;
    gap: 0.8rem;
    @media (max-width: ${breakpoint.phone}) {
        min-width: unset;
        flex-wrap: wrap;
        flex-grow: 1;
    }
`;

export const LocationWrapper = styled.div`
    font-size: 14px;
    line-height: 18px;
    color: ${colors.textPrimary};
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    min-width: 0;
    max-width: 100%;
`;

export const LocationWrapperTooltip = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const LocationWrapperTooltipName = styled.div`
    color: ${colors.textGrey1};
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
`;

export const LocationWrapperTooltipAddress = styled.div`
    color: ${colors.textGrey2};
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
`;
